import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";
import '@angular/localize/init';
import 'hammerjs';
import { environment } from './environments/environment';

if (environment.name == "prod") {
  Sentry.init({
    dsn: "https://5f2a2b35af8d2d61856eb3c9b08e4fb7@o1385031.ingest.us.sentry.io/4508443755347968",
    environment: window.location.href.lastIndexOf('preprod') > -1 ? "PREPROD" : "PROD",
    integrations: [
      Sentry.browserTracingIntegration(),
      //Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
